import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss'
})
export class IconComponent {
  @Input() name!: string;  // Nome dell'icona (es. "check", "close", "menu")
  @Input() width: number = 24;  // Larghezza predefinita
  @Input() height: number = 24; // Altezza predefinita
  @Input() color: string = 'currentColor'; // Colore SVG personalizzabile
}
